import React from 'react';

/** Renders bot text with simple **bold** markers (same as full-page chatbot). */
export function renderAdmissionsBotText(text: string): React.ReactNode {
  const nodes: React.ReactNode[] = [];
  let cursor = 0;
  let key = 0;

  while (cursor < text.length) {
    const start = text.indexOf('**', cursor);
    if (start === -1) {
      nodes.push(text.slice(cursor));
      break;
    }

    const end = text.indexOf('**', start + 2);
    if (end === -1) {
      nodes.push(text.slice(cursor));
      break;
    }

    if (start > cursor) {
      nodes.push(text.slice(cursor, start));
    }

    const boldText = text.slice(start + 2, end);
    nodes.push(<strong key={`b-${key++}`}>{boldText}</strong>);

    cursor = end + 2;
  }

  return nodes;
}
